import Requisicao from "./RequisicaoService";

class LogradouroService {
    static async listar() {
        return Requisicao.get('endereco/logradouro');
    }    
}

export default LogradouroService;